import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import Group from 'components/utils/Group'
import LineUserIcon from 'LuxKit/Icons/line/LineUserIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import OfferFilterSelectBox from 'components/OfferPage/Filters/OfferFilterSelectBox'
import noop from 'lib/function/noop'

interface MappedStateProps {
  businessAccount?: App.BusinessTraveller.CurrentBusinessAccount
}

interface Props {
  className?: string
}

function BusinessTravellerSelectHotelsOfferPageDesktopDisabled(props: Props & MappedStateProps) {
  const {
    className,
    businessAccount,
  } = props

  const travellerValue = useMemo(() => {
    if (!businessAccount?.employee) {
      return undefined
    }
    const { firstName = '', lastName = '' } = businessAccount.employee
    const name = `${firstName} ${lastName}`.trim()
    return name ? <b>{name}</b> : undefined
  }, [businessAccount?.employee])

  return (
    <Group className={className} direction="horizontal" gap={8}>
      <OfferFilterSelectBox
        icon={<LineUserIcon />}
        label="Travellers"
        placeholder="Select travellers"
        value={travellerValue}
        disabled
        onClick={noop}
      />
      <OfferFilterSelectBox
        icon={<LineBedIcon />}
        label="Rooms"
        placeholder="Select rooms"
        value={<b>1 room</b>}
        disabled
        onClick={noop}
      />
    </Group>
  )
}

export default connect<MappedStateProps, {}, Props, App.State>((state) => {
  return {
    businessAccount: state.businessTraveller.currentBusinessAccount,
  }
})(BusinessTravellerSelectHotelsOfferPageDesktopDisabled)
